/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const BookOpenText = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" }],
    ["path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" }],
    ["path", { d: "M6 8h2" }],
    ["path", { d: "M6 12h2" }],
    ["path", { d: "M16 8h2" }],
    ["path", { d: "M16 12h2" }]
  ]
];

export { BookOpenText as default };
//# sourceMappingURL=book-open-text.js.map
